<template>
  <div v-if="isVisible" class="auth-modal-overlay">
    <div class="auth-modal-content">
      <p>{{ localeContent.message }}</p>
      <div class="auth-modal-actions">
        <button @click="login">{{ localeContent.loginButton }}</button>
        <button @click="register">{{ localeContent.registerButton }}</button>
        <button @click="close">{{ localeContent.closeButton }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { languageStore } from '../languageStore';

export default {
  name: 'AuthModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'login', 'register'],
  setup(props, { emit }) {
    const localeContent = ref({});

    const loadLocaleContent = async (lang) => {
      try {
        const module = await import(`../locales/components/AuthModal_${lang}.json`);
        localeContent.value = module.default;
      } catch (error) {
        console.error('Failed to load locale content for AuthModal:', error);
      }
    };

    watch(() => languageStore.currentLanguage, async (newLang) => {
      if (newLang) {
        await loadLocaleContent(newLang);
      }
    }, { immediate: true });

    const close = () => {
      emit('close');
    };

    const login = () => {
      emit('login');
    };

    const register = () => {
      emit('register');
    };

    return {
      close,
      login,
      register,
      localeContent,
    };
  },
};
</script>

<style scoped>
.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.auth-modal-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  color: #333;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
}

.auth-modal-content p {
  font-size: 1.2rem;
  margin-bottom: 25px;
  line-height: 1.5;
}

.auth-modal-actions button {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 12px 25px;
  margin: 0 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.auth-modal-actions button:hover {
  background-color: #369c6d;
  transform: translateY(-2px);
}

.auth-modal-actions button:active {
  transform: translateY(0);
}

.auth-modal-actions button:last-child {
  background-color: #f44336;
}

.auth-modal-actions button:last-child:hover {
  background-color: #d32f2f;
}
</style>
